// extracted by mini-css-extract-plugin
export default {"Box":"table-header-module__Box--r_Qif","Box_1":"table-header-module__Box_1--sNz9u"};